import axios from 'axios'
import { Message } from 'element-ui'
// import store from '../store'
// import { getToken } from '@/utils/auth'

import $token from '@/utils/token'
import router from '@/router'
import i18n from '@/i18n'

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 180000,// 请求超时时间
  headers: { platform: "admin__a_d_m_i_n" }
})

// request拦截器
service.interceptors.request.use(config => {
  let token = $token.get()
  if (token) {
    config.headers['token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

let message = null;

// respone拦截器
service.interceptors.response.use(
  res => {
    // yhub周报页面不需要登录
    const isReport = location.href.indexOf('/w/yhub') >= 0;
    const isLogin = location.href.indexOf('/login') >= 0;
    
    const data = res.data
    if (data.resultCode == 401 || data.resultMessage == 'token_error') {
      if (!isReport && !isLogin) {
        router.push('/login')
        if (!message) {
          message = Message({
            message: i18n.t('login.login_first'),
            type: 'error',
            duration: 5 * 1000
          })

          setTimeout(() => {
            message = null;
          }, 2000);
        }
        
      }
      

    } else if (data.resultCode == 104) {
      Message.error(i18n.t('login.passwordWrong'))
    } else if (data.resultCode === 202) {
      Message.error(i18n.t('login.notAlloweLogin'))
    }
    return data

  }
)

export default service
